export default __webpack_public_path__ + "static/media/bg-map.b19e64e6.png";